/**
 * Web InputMasked Context
 *
 */

import React from 'react'

const InputMaskedContext = React.createContext({})

export default InputMaskedContext
